/*SYSTEM IMPORTS*/
    import React from 'react'
    // import c from 'classnames'


    const GlassesIcon = () => (
        <span    className="icon glasses-icon">
            <svg width="30" height="13" viewBox="0 0 30 13" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M29.8755 3.5943L29.1286 3.97867C29.2531 15.5099 16.805 15.2536 16.4315 3.72242L16.9295 2.95368C15.9336 2.44118 14.0664 2.44118 12.9461 2.95368L13.444 3.72242C12.9461 15.2536 0.622407 15.5099 0.746888 3.97867L0 3.5943V1.41618C4.85477 -0.249431 7.71784 -0.633803 12.5726 1.28806C14.3154 1.03181 15.6846 1.03181 17.4274 1.28806C22.2822 -0.633803 25.1452 -0.121306 30 1.41618V3.5943H29.8755Z" fill="#5278DF"/>
            </svg>
        </span>
    )

    export default GlassesIcon
